const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

export const WorkAssignmentQueryURL = {
    GetContext: (featureKey: string) => Backofficebff + `/v1/work-assignment/${featureKey}/context`,
    GetAssignees: (featureKey: string) => Backofficebff + `/v1/work-assignment/${featureKey}/assignees`,
};
